<template>
  <section id="image-view">
    <img v-if="image" :src="image" alt="Image" style="height: 100vh;" />
  </section>
</template>

<script>
export default {
  name: 'ImageView',
  metaInfo: {
    title: 'SmartAC.com | Image View',
  },
  data() {
    return {
      image: '',
    };
  },
  async mounted() {
    const src = this.$route && this.$route.query ? this.$route.query.src : '';
    if (typeof src !== 'string' || !src) {
      this.image = '';
      return;
    }

    if (src.startsWith('data:image/') || src.startsWith('blob:') || src.startsWith('/')) {
      this.image = src;
      return;
    }

    if (src.startsWith('https://') || src.startsWith('http://')) {
      this.image = await this.$store.dispatch('getImageResponse', { url: src });
      return;
    }

    this.image = '';
  },
};
</script>
